export default "__VITE_ASSET__NIly0ayX__"